import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { FormGroup, Input, Label, Spinner } from "reactstrap";
import { connect, useDispatch } from "react-redux";

import {
  receiveMessages,
  receiveMessage,
  fetchRecipient,
  resetUnreadMessageCount,
  receiveLastMessages,
  sendMessage,
  resetRecipient,
  resetMessages,
} from "./ChatRedux";
import { updateChannel } from "./ChannelsRedux";
import Message from "./ChatComponents/Message";
import ChatNav from "./ChatComponents/ChatNav";
import SendLicenseRequest from "../../Shared/Licensing/licensing_components/_send_license_request";
import LicenseMessageContainer from "../../Shared/Licensing/license_message_container";
// import { Loader } from '../../shared/loader';
import { find } from "../../utilities";
import "../../chat.css.scss";
import { ChevronLeft } from "react-feather";

const uIdFromCookie = Cookies.get("uId");
const ChatDetail = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [textMessage, setTextMessage] = useState("");
  const [currentChannel, setCurrentChannel] = useState("");
  const [user, setUser] = useState({});
  const [influencer, setInfluencer] = useState({});
  const [note, setNote] = useState({});
  const [myImage, setMyImage] = useState(
    require("@src/assets/images/vyrill/default-profile.png").default
  );
  const [recipientImage, setRecipientImage] = useState(
    require("@src/assets/images/vyrill/default-profile.png").default
  );
  const {
    // location: { search, state, pathname },
    // match: {
    //   params: { id },
    // },
    currentUser: { first_name, last_name },
    recipients: { users, influencers },
    messages,
    notes,
    currentInfluencer,
    licenseRequestVideo,
    newChatRecipient,
    // messagesFetchedForChannel,
    // channels,
  } = props;
  const _id = props.currentUser._id || uIdFromCookie;

  const location = useLocation();
  const { pathname, search, state } = location;
  const navigate = useNavigate();
  const { id } = useParams();
  const queryParams = new URLSearchParams(search);
  const fromInfluencers = queryParams.get("fromInfluencers") || undefined;
  const isVideoAuthorId = (state && state.isVideoAuthorId) || fromInfluencers;
  // const { isVideoAuthorId } = location.state || {}; // DO: FIX global history in Route/react-router to avoid queryParams
  const currentChatUser = newChatRecipient.user;

  const pubnub = window && window.pubnub;
  // const getCurrentChatUser = (users, newChatRecipient) => users.find(({ _id }) => _id === id) || newChatRecipient.user;

  const getCurrentChatChannel = (id, _id, isVideoAuthorId, currentChatUser) =>
    isVideoAuthorId
      ? [currentChatUser._id, _id].sort().join("-")
      : [id, _id].sort().join("-");

  const getCurrentChatInfluencer = (currentChatUser) => {
    let currentChatInfluencer = false;
    currentChatInfluencer = influencers.find(
      ({ channel_url }) => channel_url === currentChatUser.youtube_channel_url
    );
    if (!currentChatInfluencer) {
      if (
        newChatRecipient.influencer.channel_url ===
        currentChatUser.youtube_channel_url
      ) {
        currentChatInfluencer = newChatRecipient.influencer;
      }
    }
    return currentChatInfluencer;
  };

  useEffect(
    () =>
      function cleanup() {
        if (currentChannel) {
          pubnub.time((status, { timetoken }) => {
            dispatch(updateChannel(currentChannel, { last_seen: timetoken }));
          });
          const receivedMessages = messages
            .filter(({ entry: { publisher } }) => publisher !== _id)
            .reverse();
          const lastReceived =
            receivedMessages[receivedMessages.length - 1] || {};
          dispatch(receiveLastMessages(currentChannel, lastReceived));
        }
        dispatch(resetRecipient());
        dispatch(resetMessages());
      },
    []
  );

  useEffect(() => {
    dispatch(fetchRecipient(id, isVideoAuthorId));
  }, [id, _id, pathname]);

  useEffect(() => {
    if (currentChatUser && currentChatUser._id) {
      setCurrentChannel(
        getCurrentChatChannel(id, _id, isVideoAuthorId, currentChatUser)
      );
    }
  }, [newChatRecipient.user, newChatRecipient.influencer]);

  useEffect(() => {
    if (currentChannel) {
      handleStateInitializer(currentChatUser);
      pubnub &&
        pubnub.history({ channel: currentChannel }, (status, { messages }) =>
          dispatch(receiveMessages(messages, currentChannel))
        );
      pubnub &&
        pubnub.addListener({
          message: ({ timetoken, channel, message }) => {
            if (currentChannel === channel) {
              dispatch(
                receiveMessage({
                  timetoken: parseInt(timetoken),
                  entry: message,
                })
              );
            }
          },
        });
      pubnub &&
        pubnub.time((status, { timetoken }) => {
          dispatch(updateChannel(currentChannel, { last_seen: timetoken }));
        });
      dispatch(resetUnreadMessageCount(currentChannel));
    }
  }, [currentChannel]);

  const handleStateInitializer = (currentChatUser) => {
    setLoading(true);
    const currentChatInfluencer = getCurrentChatInfluencer(currentChatUser);
    if (currentChatInfluencer) {
      setInfluencer(currentChatInfluencer);
      setNote(find(notes, currentChatInfluencer._id, "video_author_id"));
    }
    if (currentChatUser) setUser(currentChatUser);
    if (currentInfluencer && currentInfluencer.author_img) {
      setMyImage(
        currentInfluencer.author_img === null ||
          currentInfluencer.author_img === ""
          ? require("@src/assets/images/vyrill/default-creators.png")
          : currentInfluencer.author_img
      );
    }

    if (currentChatInfluencer && currentChatInfluencer.author_img) {
      setRecipientImage(
        currentChatInfluencer.author_img === null ||
          currentChatInfluencer.author_img === ""
          ? require("@src/assets/images/vyrill/default-creators.png")
          : currentChatInfluencer.author_img
      );
    } else {
      setRecipientImage(
        currentChatUser.is_youtube_connected
          ? require("@src/assets/images/vyrill/default-creators.png")
          : require("@src/assets/images/vyrill/default-profile.png")
      );
    }
    setLoading(false);
  };

  const handleSubmit = () => {
    pubnub.publish({
      channel: currentChannel,
      message: {
        message: textMessage,
        publisher: _id,
      },
    });
    pubnub.publish({
      channel: "vyrill",
      message: {
        channel: currentChannel,
        user: [first_name, last_name].join(" "),
        user_id: _id,
        entry: { message: textMessage },
      },
      storeInHistory: false,
    });
    setTextMessage("");
    dispatch(sendMessage(user._id));
  };

  const handleTextMessage = ({ target }) => {
    setTextMessage(target.value);
  };

  const getEmail = (chatRecipient) => {
    const { user, influencer } = chatRecipient || {};
    if (user && user.email) {
      return user.email;
    }
    if (influencer && influencer.email) {
      return influencer.email;
    }
    return "";
  };

  if (loading) {
    return (
      <div className="chat-page ChatDetail">
        <div className="chat">
          <div className="chat-content">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "350px" }}
            >
              <Spinner />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="chat-page ChatDetail">
      <div className="chat">
        <div className="chat-header">
          <Link to="/chat">
            <ChevronLeft />
            Back to Inbox
          </Link>
        </div>
        <ChatNav
          user={user}
          influencer={influencer}
          recipientImage={recipientImage}
          note={note}
          loading={loading}
        />
        <div className="chat-content">
          <div className="chat-profile">
            {influencer && influencer._id && (
              <div className="button-container">
                <Link
                  to={`/influencers/${influencer._id}`}
                  className="btn btn-outline-primary float-end"
                >
                  View Creator Profile
                </Link>
              </div>
            )}
            {licenseRequestVideo._id ? (
              <SendLicenseRequest
                videoId={licenseRequestVideo._id}
                influencerAdminId={id}
                influencerEmail={getEmail(newChatRecipient)}
                channel={currentChannel}
              />
            ) : (
              <div className="chat-message-container">
                <FormGroup>
                  <Label htmlFor="textMessage" for="textMessage">
                    <b>Type your message:</b>
                  </Label>
                  <Input
                    id="textMessage"
                    type="textarea"
                    onChange={handleTextMessage}
                    value={textMessage}
                  />
                </FormGroup>
                <div className="button-container mb-2">
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-outline-primary float-end"
                  >
                    Send message
                  </button>
                </div>
              </div>
            )}
            <div className="messages">
              {messages &&
                messages.length > 0 &&
                messages.map(
                  ({ entry: { message, publisher, meta }, timetoken }, index) =>
                    meta ? (
                      <LicenseMessageContainer
                        influencer={influencer}
                        meta={meta}
                        message={message}
                        isSender={publisher === _id}
                        user={user}
                        channel={currentChannel}
                        image={publisher === _id ? myImage : recipientImage}
                        key={`message-${index}`}
                        timetoken={timetoken}
                      />
                    ) : (
                      <Message
                        message={message}
                        timetoken={timetoken}
                        image={publisher === _id ? myImage : recipientImage}
                        key={`message-${index}`}
                        isOwnMessage={publisher === _id}
                        first_name={first_name}
                        last_name={last_name}
                      >
                        <pre>{message}</pre>
                      </Message>
                    )
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ChatDetail.defaultProps = {};

ChatDetail.propTypes = {};

const mapStateToProps = ({
  navbarStatsReducer: { current_user, influencer: currentInfluencer },
  // channels,
  messages,
  recipients,
  influencerNotes: notes,
  messagesFetchedForChannel,
  newChatRecipient,
  licenseRequestVideo,
}) => ({
  currentUser: current_user,
  currentInfluencer,
  // channels,
  messages,
  recipients,
  notes,
  messagesFetchedForChannel,
  newChatRecipient,
  licenseRequestVideo,
});

export default connect(mapStateToProps)(ChatDetail);
